import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon DocumentsIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const DocumentsIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 70 70">
      <g id="Group_4146">
        <g id="Group_4145">
          <g id="Group_4143">
            <g id="Group_4136">
              <g id="Group_4133">
                <g id="Path_1919">
                  <path d="M29.18,56.67c-1.15,0-2.09-0.01-2.34-0.05c-1.01-0.14-1.44-1.12-1.35-2.04v-1.66 c0-0.57,0.46-1.03,1.03-1.03c0.57,0,1.03,0.46,1.03,1.03v1.68c1.14,0.02,4.15,0,6.28-0.03h17.49c0.05,0,0.09,0,0.13,0 c0.02-1.91,0.01-23.35,0-34.84l0,0h-9.23c-0.57,0-1.03-0.46-1.03-1.03s0.46-1.03,1.03-1.03h9.5c1.01,0,1.62,0.88,1.77,1.75 l0.02,0.19c0,1.39,0.03,34.1,0,35.11c-0.02,0.71-0.35,1.15-0.63,1.39c-0.65,0.58-1.5,0.52-1.67,0.51H33.84 C32.75,56.64,30.77,56.67,29.18,56.67z M27.56,54.9h0.01H27.56z" />
                </g>
              </g>
            </g>
            <g id="Group_4140">
              <g id="Group_3983">
                <g id="Path_1880">
                  <path d="M51.81,41.43h-4.34c-0.57,0-1.03-0.46-1.03-1.03s0.46-1.03,1.03-1.03h4.34c0.57,0,1.03,0.46,1.03,1.03 S52.38,41.43,51.81,41.43z" />
                </g>
                <g id="Path_1994">
                  <path d="M51.81,35.69h-4.34c-0.57,0-1.03-0.46-1.03-1.03s0.46-1.03,1.03-1.03h4.34c0.57,0,1.03,0.46,1.03,1.03 S52.38,35.69,51.81,35.69z" />
                </g>
                <g id="Path_1996">
                  <path d="M51.81,29.95h-4.34c-0.57,0-1.03-0.46-1.03-1.03c0-0.57,0.46-1.03,1.03-1.03h4.34 c0.57,0,1.03,0.46,1.03,1.03C52.84,29.48,52.38,29.95,51.81,29.95z" />
                </g>
                <g id="Path_1881">
                  <path d="M50.59,46.15h-3.12" />
                  <path d="M50.59,47.18h-3.12c-0.57,0-1.03-0.46-1.03-1.03s0.46-1.03,1.03-1.03h3.12c0.57,0,1.03,0.46,1.03,1.03 C51.61,46.71,51.15,47.18,50.59,47.18z" />
                </g>
              </g>
            </g>
          </g>
          <g id="Group_4245">
            <g id="Group_4133-2">
              <g id="Path_2085">
                <g>
                  <path
                    fill="none"
                    d="M17.5,14.41c0,0,17.47,0.04,19.53,0c2.06-0.04,1.88-0.02,2.24,0.16c0.37,0.19,7.65,6.66,7.65,6.66 c0.42,0.34,0.44,0.93,0.43,1.75s0,28.47,0,28.47c0,1.13-0.93,2.06-2.06,2.06H17.5c-1.13,0-2.06-0.93-2.06-2.06V16.47 C15.44,15.34,16.37,14.41,17.5,14.41z"
                  />
                </g>
                <g>
                  <path d="M38.24,16.46c-0.27,0-0.65,0-1.17,0.01c-0.62,0.01-2.65,0.02-6.01,0.02c-5.72,0-13.48-0.02-13.55-0.02 v35H45.3c0-1.13,0-27.67,0-28.49c0-0.1,0-0.28,0-0.43c-2.51-2.23-5.96-5.27-6.95-6.09C38.32,16.46,38.29,16.46,38.24,16.46 L38.24,16.46 M38.25,14.39c0.79,0,0.76,0.04,1.03,0.19c0.37,0.19,7.65,6.66,7.65,6.66c0.42,0.34,0.44,0.93,0.43,1.75 c0,0.83,0,28.47,0,28.47c0,1.13-0.93,2.06-2.06,2.06H17.5c-1.13,0-2.06-0.93-2.06-2.06V16.47c0-1.13,0.93-2.06,2.06-2.06 c0,0,17.47,0.04,19.53,0c0.55,0,0.93-0.01,1.21-0.01L38.25,14.39z" />
                </g>
              </g>
            </g>
          </g>
          <g id="Group_4144">
            <g id="Group_4142">
              <g id="Group_4136-2">
                <g id="Group_4133-3">
                  <g id="Path_1883">
                    <path d="M46.33,23.22c-0.01,0-0.01,0-0.02,0l-8.11-0.18c-0.94-0.03-2.16-0.28-2.2-2.08v-5.53 c0-0.53,0.4-0.97,0.93-1.02c0.71-0.07,1.43-0.02,2.13,0.14c0.17,0.04,0.34,0.13,0.46,0.25c0.3,0.24,0.99,0.82,2.82,2.43 c1.18,1.04,2.67,2.33,2.93,2.53c0.72,0.61,1.3,1.15,1.82,1.71c0.28,0.3,0.35,0.74,0.19,1.12 C47.11,22.99,46.74,23.22,46.33,23.22z M38.06,20.98c0.05,0,0.11,0.01,0.2,0.01l5.37,0.11c-0.49-0.41-1.4-1.2-2.66-2.3 c-1-0.86-2.2-1.93-2.64-2.27c-0.09-0.02-0.2-0.03-0.29-0.04v4.47C38.06,20.96,38.06,20.97,38.06,20.98z" />
                  </g>
                </g>
              </g>
              <g id="Group_4140-2">
                <g id="Group_3983-2">
                  <g id="Path_1880-2">
                    <path d="M39.87,36.84H21.55c-0.57,0-1.03-0.46-1.03-1.03s0.46-1.03,1.03-1.03h18.32 c0.57,0,1.03,0.46,1.03,1.03S40.44,36.84,39.87,36.84z" />
                  </g>
                  <g id="Path_1995">
                    <path d="M39.87,27.58H21.55c-0.57,0-1.03-0.46-1.03-1.03s0.46-1.03,1.03-1.03h18.32 c0.57,0,1.03,0.46,1.03,1.03S40.44,27.58,39.87,27.58z" />
                  </g>
                  <g id="Path_1882">
                    <path d="M30.48,44.05h-8.95" />
                    <path d="M30.48,45.08h-8.95c-0.57,0-1.03-0.46-1.03-1.03s0.46-1.03,1.03-1.03h8.95 c0.57,0,1.03,0.46,1.03,1.03C31.51,44.61,31.05,45.08,30.48,45.08z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </Icon>
  )
}
export default DocumentsIcon
